import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'app-logo',
  imports: [RouterLink],
  template: `
    <a routerLink="/" class="logo logo-brand">
      <span class="logo-mark logo-light">
        <span class="logo-lg">
          <img src="assets/images/logos/logo-light.png" alt="" />
        </span>
        <span class="logo-sm">
          <img src="assets/images/logos/logo-light.png" alt="DWH" />
        </span>
      </span>

      <span class="logo-mark logo-dark">
        <span class="logo-lg">
          <img src="assets/images/logos/logo-dark.png" alt="" />
        </span>
        <span class="logo-sm">
          <img src="assets/images/logos/logo-dark.png" alt="DWH" />
        </span>
      </span>

      <span class="logo-copy">
        <span class="logo-title">Web Admin</span>
        <span class="logo-subtitle">Data Warehouse</span>
      </span>
    </a>
  `,
  styles: `
    :host {
      display: block;
    }

    .logo-brand {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 12px;
      height: 70px;
      padding: 0 16px;
      text-decoration: none;
      line-height: normal;
      background: rgba(0, 0, 0, 0.08);
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transition: background 0.25s ease;
    }

    .logo-brand:hover {
      background: rgba(0, 0, 0, 0.14);
    }

    .logo-mark {
      display: none;
      flex-shrink: 0;
      line-height: 0;
    }

    .logo-mark .logo-lg {
      display: block;
    }

    .logo-mark .logo-sm {
      display: none;
    }

    .logo-mark img {
      display: block;
      height: 42px;
      width: auto;
      max-width: 88px;
      object-fit: contain;
      transition: transform 0.25s ease;
    }

    .logo-brand:hover .logo-mark img {
      transform: scale(1.04);
    }

    .logo-copy {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 1px;
      min-width: 0;
      text-align: left;
    }

    .logo-title {
      display: block;
      color: #ffffff;
      font-size: 1rem;
      font-weight: 700;
      letter-spacing: 0.02em;
      line-height: 1.2;
      white-space: nowrap;
    }

    .logo-subtitle {
      display: block;
      color: rgba(255, 255, 255, 0.55);
      font-size: 0.6875rem;
      font-weight: 500;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      line-height: 1.2;
      white-space: nowrap;
    }

    :host-context(html[data-menu-color='light']) .logo-brand,
    :host-context(html[data-menu-color='gray']) .logo-brand {
      background: rgba(15, 23, 42, 0.03);
      border-bottom-color: rgba(15, 23, 42, 0.08);
      box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
    }

    :host-context(html[data-menu-color='light']) .logo-brand:hover,
    :host-context(html[data-menu-color='gray']) .logo-brand:hover {
      background: rgba(15, 23, 42, 0.06);
    }

    :host-context(html[data-menu-color='light']) .logo-title,
    :host-context(html[data-menu-color='gray']) .logo-title {
      color: #1e1d60;
    }

    :host-context(html[data-menu-color='light']) .logo-subtitle,
    :host-context(html[data-menu-color='gray']) .logo-subtitle {
      color: rgba(30, 29, 96, 0.55);
    }

    /* Light logo (white) on dark / gradient menus */
    :host-context(html[data-menu-color='gradient']) .logo-light,
    :host-context(html[data-menu-color='dark']) .logo-light,
    :host-context(html[data-menu-color='image']) .logo-light,
    :host-context(html[data-bs-theme='dark']) .logo-light {
      display: block;
    }

    :host-context(html[data-menu-color='gradient']) .logo-dark,
    :host-context(html[data-menu-color='dark']) .logo-dark,
    :host-context(html[data-menu-color='image']) .logo-dark,
    :host-context(html[data-bs-theme='dark']) .logo-dark {
      display: none;
    }

    /* Dark logo on light menus */
    :host-context(html[data-menu-color='light']) .logo-dark,
    :host-context(html[data-menu-color='gray']) .logo-dark {
      display: block;
    }

    :host-context(html[data-menu-color='light']) .logo-light,
    :host-context(html[data-menu-color='gray']) .logo-light {
      display: none;
    }

    /* Condensed: icon only */
    :host-context(html[data-sidenav-size='condensed']) .logo-copy {
      display: none;
    }

    :host-context(html[data-sidenav-size='condensed']) .logo-brand {
      justify-content: center;
      padding: 0;
      gap: 0;
    }

    :host-context(html[data-sidenav-size='condensed']) .logo-mark .logo-lg {
      display: none;
    }

    :host-context(html[data-sidenav-size='condensed']) .logo-mark .logo-sm {
      display: block;
    }

    :host-context(html[data-sidenav-size='condensed']) .logo-mark img {
      height: 36px;
      max-width: 48px;
    }
  `,
})
export class AppLogo {}
